<script setup lang="ts"></script>

<template>
  <span :class="$style.accentMarker">
    <slot></slot>
  </span>
</template>

<style lang="scss" module>
@import '_constants.scss';
.accentMarker {
  background: linear-gradient(transparent 64%, $color-orange-300 0%);
}
</style>
